export default __webpack_public_path__ + "static/media/photo--sm--12.038151c5.jpg";